export const SESSION_STATUS = {
  UPCOMING: "upcoming",
  LATE_JOIN: "late_join",
  MISSED: "missed",
  ENDED: "ended",
  EXPIRED: "expired",
} as const;
